import React, { Dispatch } from "react";
import _ from "lodash";
import dayjs, {Dayjs} from 'dayjs'
import { ActionType, API } from "../../resources/constants";

// Interfaces
import { AxiosError } from "../../interfaces/axios";
import { Source, Tender, Filter, PrimaryFilter } from "../../interfaces/pages/opportunities";
import { ClassificationsForm } from "../../interfaces/pages/profile"

const { SET_TENDERS_DASHBOARD, SET_FILTER, SET_TENDERS, SET_TENDERS_PAGINATION, SET_SOURCES, SET_DEFAULT_SOURCE, SET_PRIMARY_FILTER, SET_POSTED_DATE } = ActionType
const { USER_MANAGEMENT_PROFILE_GET_CLASSIFICATION, TENDER_TENDER_PAGINATE, TENDER_SOURCE_PAGINATE } = API;

export const getTenders = (axios: {get: any, post: any, delete: any, put: any, patch: any, interceptors: any}, primaryFilter: PrimaryFilter, postedDate: [Dayjs, Dayjs]|null, defaultSource: string, dispatch: Dispatch<{ type: string, payload: object }>, setTendersDashboard: boolean = false, source: string[] = []) => axios.get(USER_MANAGEMENT_PROFILE_GET_CLASSIFICATION, { params: { source: (source && !_.isEmpty(source)) ? source[0] : defaultSource } }).then((response: { data: ClassificationsForm }) => {
    let { data: { naicsCodes = [], pscCodes = [], gsinCodes = [], unspscCodes = [], buyersInclude = [], buyersExclude = [], setAsideCodes = [], agreementCodes = [], opportunities = [defaultSource], noticeTypes = []} } = response
    opportunities = (source && !_.isEmpty(source)) ? source : (opportunities && !_.isEmpty(opportunities)) ? opportunities : [defaultSource];
    const filter: Filter = {
        buyersInclude,
        buyersExclude,
        naicsCodes,
        pscCodes,
        gsinCodes,
        unspscCodes,
        setAside: setAsideCodes,
        agreement: agreementCodes,
        source: opportunities,
        noticeType: noticeTypes,
        postedDate,
    };
    !setTendersDashboard && dispatch({ type: SET_POSTED_DATE, payload: { postedDate }})
    !setTendersDashboard && dispatch({ type: SET_DEFAULT_SOURCE, payload: { defaultSource: opportunities[0] }})
    axios.post(TENDER_TENDER_PAGINATE, {
        agency: !_.isEmpty(buyersInclude) ? buyersInclude : undefined,
        agencyExclude: !_.isEmpty(buyersExclude) ? buyersExclude : undefined,
        naicsCode: !_.isEmpty(naicsCodes) ? naicsCodes : undefined,
        pscCode: !_.isEmpty(pscCodes) ? pscCodes : undefined,
        gsinCode: !_.isEmpty(gsinCodes) ? gsinCodes : undefined,
        unspscCode: !_.isEmpty(unspscCodes) ? unspscCodes : undefined,
        setAside: !_.isEmpty(setAsideCodes) ? setAsideCodes.map((setAsideCode: string) => (setAsideCode === 'Without Set Aside Code') ? 'null' : setAsideCode) : undefined,
        agreement: !_.isEmpty(agreementCodes) ? agreementCodes.map((agreementCode: string) => (agreementCode === 'Without Agreement Code') ? 'null' : agreementCode) : undefined,
        source: opportunities,
        noticeType: !_.isEmpty(noticeTypes) ? noticeTypes : undefined,
        publishDate: postedDate ? [postedDate[0].format('YYYY-MM-DD'), postedDate[1].format('YYYY-MM-DD')] : undefined,
        ...primaryFilter,
    }, { params: { page: 0, size: 6, source: opportunities[0] } }).then((response: { data: {
            items: Tender[],
            total: number,
            type: { [source: string]: number },
        }}) => {
        const { items: tenders = [], total, type } = response.data
        const tendersDashboard: { [source: string]: number } = {};
        for (const item of source) {
            tendersDashboard[item] = type[item] || 0;
        }
        setTendersDashboard && dispatch({ type: SET_TENDERS_DASHBOARD, payload: { tendersDashboard: tendersDashboard }})
        !setTendersDashboard && dispatch({ type: SET_TENDERS, payload: { tenders }})
        !setTendersDashboard && dispatch({ type: SET_TENDERS_PAGINATION, payload: { tendersPagination: {
                    page: 1,
                    pageSize: 6,
                    total,
                }}})
        !setTendersDashboard && dispatch({ type: SET_FILTER, payload: { filter }})
        !setTendersDashboard && dispatch({ type: SET_PRIMARY_FILTER, payload: { primaryFilter }})
    }).catch((error: AxiosError) => {})
}).catch(async (error: AxiosError) => {
    const opportunities = (source && !_.isEmpty(source)) ? source : [defaultSource];
    const filter: Filter = {
        source: opportunities,
        postedDate,
    };
    !setTendersDashboard && dispatch({ type: SET_DEFAULT_SOURCE, payload: { defaultSource: opportunities[0] }})
    !setTendersDashboard && dispatch({ type: SET_POSTED_DATE, payload: { postedDate }})
    axios.post(TENDER_TENDER_PAGINATE, {
        source: opportunities,
        publishDate: postedDate ? [postedDate[0].format('YYYY-MM-DD'), postedDate[1].format('YYYY-MM-DD')] : undefined,
        ...primaryFilter,
    }, { params: { page: 0, size: 6, source: opportunities[0] } }).then((response: { data: {
            items: Tender[],
            total: number,
            type: { [source: string]: number },
        }}) => {
        const { items: tenders = [], total, type } = response.data;
        const tendersDashboard: { [source: string]: number } = {};
        for (const item of source) {
            tendersDashboard[item] = type[item] || 0;
        }
        setTendersDashboard && dispatch({ type: SET_TENDERS_DASHBOARD, payload: { tendersDashboard: tendersDashboard }})
        !setTendersDashboard && dispatch({ type: SET_TENDERS_PAGINATION, payload: { tendersPagination: {
                    page: 1,
                    pageSize: 6,
                    total,
                }}})
        !setTendersDashboard && dispatch({ type: SET_TENDERS, payload: { tenders }})
        !setTendersDashboard && dispatch({ type: SET_FILTER, payload: { filter }})
        !setTendersDashboard && dispatch({ type: SET_PRIMARY_FILTER, payload: { primaryFilter }})
    }).catch((error: AxiosError) => {})
})

export const getSources = (axios: {get: any, post: any, delete: any, put: any, patch: any, interceptors: any}, dispatch: Dispatch<{ type: string, payload: object }>) => axios.post(TENDER_SOURCE_PAGINATE, {}, { params: { page: 0, size: 100 } }).then((response: { data: {
        items: Source[],
        total: number,
    }}) => {
    const { data: { items: sources, total} } = response
    dispatch({ type: SET_SOURCES, payload: { sources }})
}).catch( (error: {}) => error )